// Entra ID (Azure AD) configuration
const ENTRA_CLIENT_ID_INTERNAL = process.env.REACT_APP_ENTRA_CLIENT_ID_INTERNAL || 'YOUR_INTERNAL_CLIENT_ID';
const ENTRA_TENANT_ID_INTERNAL = process.env.REACT_APP_ENTRA_TENANT_ID_INTERNAL || 'YOUR_INTERNAL_TENANT_ID';
const BASENAME = process.env.PUBLIC_URL || '';

const REDIRECT_URI = `${window.location.origin}${BASENAME}/login/callback`;
const MATOMO_SERVER = process.env.REACT_APP_MATOMO_SERVER || 'https://ec2-3-16-147-194.us-east-2.compute.amazonaws.com';
const MATOMO_SITEID = process.env.REACT_APP_MATOMO_SITEID || '1';
const MATOMO_ENABLED = process.env.REACT_APP_MATOMO_ENABLED || true;
const CONFIGCAT_KEY = process.env.REACT_APP_CONFIGCAT_KEY || 'tvLbCGAedUWMVti-TCxXKg/BXszNGKfAU6fThmkD03wEg'; // <-- ConfigCat Development environment key
const BPO_GLOBAL_MAILBOX = 'Global.GCPContinuousImprovement@takeda.com';
const config = {
  basename: BASENAME,
  bpoGloblMailbox: BPO_GLOBAL_MAILBOX,
  defaultPath: '/',
  fontFamily: `'Roboto', sans-serif`,
  borderRadius: 12,
  entra: {
    internal: {
      auth: {
        clientId: ENTRA_CLIENT_ID_INTERNAL,
        authority: `https://login.microsoftonline.com/${ENTRA_TENANT_ID_INTERNAL}/v2.0`,
        redirectUri: REDIRECT_URI,
        postLogoutRedirectUri: window.location.origin + '/logout',
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
      },
      system: {
        allowNativeBroker: false,
      },
    },
    scopes: ['openid', 'profile', 'email'],
  },
  matomo: {
    enabled: MATOMO_ENABLED,
    serverUrl: MATOMO_SERVER,
    siteId: MATOMO_SITEID,
  },
  configCat: {
    sdkKey: CONFIGCAT_KEY,
  },
};

export default config;
